import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { FilePlus2, PackagePlus, UserPlus } from "lucide-react";

import { useAuth } from "../../../app/providers/AuthProvider";
import { hasPermission, Permission } from "../../../app/permissions";

function Tile({ to, icon: Icon, label, testId }) {
  return (
    <Link
      to={to}
      data-testid={testId}
      className="group flex w-full items-center gap-4 rounded-md border border-border-subtle bg-charcoal p-5 text-white transition-colors hover:bg-charcoal-soft focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-champagne sm:h-[140px] sm:w-[280px] sm:flex-col sm:items-start sm:justify-between"
    >
      <Icon className="h-8 w-8 text-champagne" aria-hidden />
      <span className="text-lg font-medium leading-tight">{label}</span>
    </Link>
  );
}

export function QuickActions() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const canProducts = hasPermission(user, Permission.ADMIN_PRODUCTS_MANAGE);
  const canUsers = hasPermission(user, Permission.ADMIN_USERS_MANAGE);

  return (
    <section data-testid="dashboard-quick-actions" className="space-y-4">
      <h2 className="text-sm font-semibold text-text-primary">
        {t("dashboard.quick_actions.heading")}
      </h2>
      <div className="flex flex-wrap gap-4">
        <Tile
          to="/orders/new"
          icon={FilePlus2}
          label={t("dashboard.quick_actions.create_order")}
          testId="quick-action-create-order"
        />
        {canProducts && (
          <Tile
            to="/products?new=1"
            icon={PackagePlus}
            label={t("dashboard.quick_actions.add_product")}
            testId="quick-action-add-product"
          />
        )}
        {canUsers && (
          <Tile
            to="/users?new=1"
            icon={UserPlus}
            label={t("dashboard.quick_actions.create_user")}
            testId="quick-action-create-user"
          />
        )}
      </div>
    </section>
  );
}
